(function(TIPTOE, w, d, $) {
  /* ================================
   * FILTER Posts in ajax
   * Sending the 'filter' action to admin-ajax,
   * Function is in tiptoe-hooks.php
   * Get resutls from cache if any, on server side & front end side
   * ================================ */

  'use strict';

  var log = TIPTOE.HAS_DEBUG
    ? w.console.log.bind(w, 'Filters:')
    : function() {};

  /**
   * Filter ajax navigation for posts with categories & tags
   * @param       {Object} options [description]
   * @constructor
   */
  function Filter(options) {
    if (!(this instanceof Filter)) return new Filter(options);
    log('constructor');

    var defaults = {};

    // default variables
    this.endpoint = window.location.origin + '/wp-admin/admin-ajax.php';
    this.$resultContainer = $('#js-results');
    this.$filterBtns = $('.js-filter');
    this.$heroContainer = $('#js-hero');
    this.$seoContainer = $('#js-seo-container');
    this.$loader = $('.ajax-loader');

    // Cache array
    this.cache = [];
    this.separator = '~|~';
    this.ajaxRequests = [];

    // Extends options
    this.options = $.extend(true, {}, defaults, options);

    return this;
  }

  /**
   * Bind events
   * @return {void}
   */
  Filter.prototype.init = function() {
    log('init');

    var self = this;

    document.querySelectorAll('.js-filter').forEach(function(filter) {
      filter.addEventListener('click', function() {
        var params = new URLSearchParams(location.search);
        var type = filter.dataset.type;
        var id = filter.dataset.id;
        var key = 'filter_' + type;

        if (params.has(key)) {
          params.set(key, id);
        } else {
          params.append(key, id);
        }

        history.replaceState(null, '', '?' + params);
      });
    });

    // TODO
    // Create a `clickHandler` method to avoid repetition
    this.$filterBtns.add('.js-filter--pagination').on('click', function(e) {
      e.preventDefault();

      var $this = $(this);
      var filter = $this.data('filter');
      var filterType = $this.data('type');
      var id = $this.data('id');
      var paged = $this.data('paged') ? $this.data('paged') : '1';

      self.ajaxCall($this, filter, filterType, id, paged);
    });

    document.addEventListener('ajaxEnd', function() {
      $('.js-filter--pagination').on('click', function(e) {
        e.preventDefault();

        var $this = $(this);
        var filter = $this.data('filter');
        var filterType = $this.data('type');
        var id = $this.data('id');
        var paged = $this.data('paged') ? $this.data('paged') : '1';

        self.ajaxCall($this, filter, filterType, id, paged);
      });
    });

    this.bindToggleElements();
  };

  Filter.prototype.bindToggleElements = function() {
    this.$filterToggle = $('.js-filters-toggle');
    this.$filterToggle.on('click', function() {
      $('html').toggleClass('is-filters-open');
    });
  }

  /**
   * Prefetch data
   * @return {void}
   */
  Filter.prototype.prefetchData = function(onlyPagination) {
    log('prefetchData', onlyPagination);

    var self = this;
    var uniqs = [];
    var requestsData = [];

    var $items = onlyPagination
      ? $('.js-filter--pagination')
      : this.$filterBtns.add('.js-filter--pagination');

    if (!$items.length) {
      log('nothing to prefetch');
      return;
    }

    $items.each(function(index, filterBtn) {
      var $filterBtn = $(filterBtn);
      var filterType = $filterBtn.data('type');
      var id = $filterBtn.data('id');
      var paged = $filterBtn.data('paged') ? $filterBtn.data('paged') : '1';
      var uniq = filterType + id + paged;

      // Do not add already cached items
      if (uniq in self.cache) {
        log(uniq + ' has already been cached.');
        return;
      }

      // Do not add alreay queued items
      if (uniqs.indexOf(uniq) > -1) {
        log(uniq + ' has already been added to the queue.');
        return;
      }

      var options = {
        url: self.endpoint,
        type: 'POST',
        data: {
          action: 'filter',
          filterType: filterType,
          id: id,
          paged: paged,
        },
        beforeSend: function() {
          log('getting content for', uniq);
        },
        success: function(response) {
          log('cache request is done for', uniq);
          var data = response.split(self.separator);
          self.cache[uniq] = data;
        },
      };

      log('adding to the queue:', uniq);
      uniqs.push(uniq);
      requestsData.push(options);
    });

    // Queue 2 ajax call at the same time
    this.queueAjaxRequests(requestsData);
    this.queueAjaxRequests(requestsData);
  };

  /**
   * Enqueue all ajax request to save data in cache
   * @param  {Array} ajaxOptions An array of all the Ajax requests' options
   * @return {void}
   */
  Filter.prototype.queueAjaxRequests = function(ajaxOptions) {
    log('queueAjaxRequests');

    if (!ajaxOptions.length) {
      log('queueAjaxRequests:', 'end of queue');
      return false;
    }

    // Get and remove the first element
    // from the options array
    var option = ajaxOptions.shift();
    $.ajax(option).always(this.queueAjaxRequests.bind(this, ajaxOptions));
  };

  /**
   * Do Ajax or provide from cache is any
   * @param  {Event}
   * @return {String} result template response
   */
  Filter.prototype.ajaxCall = function(
    $trigger,
    filter,
    filterType,
    id,
    paged
  ) {
    log('ajaxCall', filter, filterType, id, paged);

    // Abort all previous ajax requests to
    // avoid strange content behaviour
    $.each(this.ajaxRequests, function(index, request) {
      request.abort();
    });

    var self = this;
    // Uniq identifier for cache
    var uniq = filterType + id + paged;

    self.animateOut();
    self.updateNav($trigger, filter, filterType, id);

    console.log('endpoint : ' + self.endpoint);

    // Use cache if possible
    if (uniq in self.cache) {
      // Wait for animateOut animation to end to avoid glitchy side-effects
      setTimeout(function() {
        self.appendNewData(self.cache[uniq]);
      }, 500);
    } else {
      var request = $.ajax({
        url: self.endpoint,
        type: 'POST',
        data: {
          action: 'filter',
          filterType: filterType,
          id: id,
          paged: paged,
        },
      })
        .always(function() {
          log('always');
        })
        .done(function(response) {
          log('done');
          var res = response.split(self.separator);
          log(res);

          self.cache[uniq] = res;
          self.appendNewData(self.cache[uniq]);
        })
        .fail(function(xhr, textStatus, message) {
          log('You failed me Anakin');
          log(xhr, textStatus, message);
        });

      // Save the request to be able
      // to cancel it when needed
      this.ajaxRequests.push(request);
    }
  };

  /**
   * Add result data to results container
   * @param {String} Template to append in result Container
   * @return {void}
   */
  Filter.prototype.appendNewData = function(data) {
    log('appendNewData');

    this.$resultContainer.append(data[0]);
    if (data.length > 1) {
      this.$heroContainer.html(data[1]);
    }

    if (data.length > 2) {
      this.$seoContainer.html(data[2]);
    }

    // Prefetch pagination data
    this.prefetchData(true);

    this.animateIn();
  };

  /**
   * Result container animateIn
   * @return {void}
   */
  Filter.prototype.animateIn = function() {
    log('animateIn');

    var self = this;

    // Trigger ajaxEnd to rebind js events
    document.dispatchEvent(TIPTOE.AJAX_END);

    // Prepare container for animateIn & restore it's height
    TweenLite.set(self.$resultContainer, {
      autoAlpha: 0,
      y: 50,
      height: 'auto',
    });
    self.$loader.removeClass('is-loading');

    // Animation
    TweenLite.to(self.$resultContainer, 0.8, {
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeOut,
    });
  };

  /**
   * Result container animateOut
   * @return {void}
   */
  Filter.prototype.animateOut = function() {
    log('animateOut');
    var self = this;

    // Loading Loading
    self.$loader.addClass('is-loading');

    // Preserve result container height to avoid ugly empty white-space
    TweenLite.set(this.$resultContainer, {
      height: this.$resultContainer.innerHeight(),
    });

    // Animation
    TweenLite.to(self.$resultContainer, 0.4, {
      autoAlpha: 0,
      ease: Expo.easeOut,
      onComplete: function() {
        // Empty container after animation
        self.$resultContainer.html('');
      },
    });
  };

  /**
   * Update Filter Navigation classes
   * @param  {Node}   $trigger
   * @param  {String} filter   New Active filter
   * @param  {String} filterType
   * @param  {String} id
   * @return {void}
   */
  Filter.prototype.updateNav = function($trigger, filter, filterType, id) {
    log('updateNav');

    var $filters = $('#filters');
    if ($filters.length) {
      var offset = $filters.offset().top;

      // Adjust scroll to fixed nav
      if (TIPTOE.IS_MOBILE_MENU) {
        offset -= $('#js-header').outerHeight();
      } else {
        offset -= $('#js-fixed-nav').outerHeight();
      }

      TweenLite.to(window, 0.6, {
        scrollTo: offset,
        ease: Expo.easeInOut,
      });
    }
    $('.products-filters__tags').css('display', 'none');
    $('#' + filter).css('display', 'flex');

    this.$filterBtns.parent().removeClass('is-active');
    // Add active class on trigger (filter or pagination)
    $trigger.parent().addClass('is-active');
    // Make sure to add/keep the active class
    // on the filter buttons
    this.$filterBtns
      .filter('[data-type="' + filterType + '"][data-id="' + id + '"]')
      .parent()
      .addClass('is-active');
  };

  // Init our Filter
  var filter = new Filter();
  filter.init();

  window.addEventListener('load', filter.prefetchData.bind(filter, false));
  // window.addEventListener('load', filter.prefetchPaginationData.bind(filter));

	$(window).on( 'wcpf_after_ajax_filtering', function() {
		filter.bindToggleElements();
	});
})(TIPTOE, window, document, jQuery);
